// ---------------------------------------------------------------------------
// Pure gating helpers for App.js's authenticated data-loading pipeline.
//
// Extracted into their own dependency-free module so the reload / live-login
// decision is unit-testable without rendering the whole App component (whose
// import chain pulls in the entire report/D3 stack).
//
// Context: on a RELOAD, App's getInitialAuthState() rehydrates from localStorage
// with userDataLoaded:true (userData + groups were cached) but
// surveyDataLoaded:false and sessionRestored:false. restoreSession() then flips
// sessionRestored:true asynchronously. The data effects must converge so that
// after the flip, fetchSurveyData runs and repopulates primaryPolls/polls
// (deliberately stripped before persisting), letting ReportHub leave its
// 'Loading...' phase. These predicates encode exactly that gate — and are
// reused both by the gated effects and by the restoreSession-success path so
// the reload pipeline fires deterministically regardless of effect re-run
// timing. The sessionRestored gate is PRESERVED (it prevents tokenless
// authenticated requests during the restore window).
// ---------------------------------------------------------------------------

export function shouldFetchUserPermissions(auth) {
	return !!(auth && auth.isLoggedIn && auth.sessionRestored && auth.userData && !auth.userDataLoaded);
}

export function shouldFetchSurveyData(auth) {
	return !!(auth && auth.isLoggedIn && auth.sessionRestored && auth.userDataLoaded && !auth.surveyDataLoaded);
}
